import { render, staticRenderFns } from "./CourseMaterialDownloadPanel.vue?vue&type=template&id=4ffc6322"
import script from "./CourseMaterialDownloadPanel.vue?vue&type=script&lang=js"
export * from "./CourseMaterialDownloadPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports